import { DepartureCommittedSearch } from '~/components/Cruises/components/shared/DepartureGridConfig';

export const departureQueryKeys = {
  all: ['departures'] as const,
  lists: () => [...departureQueryKeys.all, 'list'] as const,
  list: (search: DepartureCommittedSearch | null, page: number, pageSize: number) =>
    [...departureQueryKeys.lists(), search, page, pageSize] as const,
};
